<ng-template #editorContent>
  <ion-header>
    @if (isDesktop()) {
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button fill="clear" (click)="dismiss()" [attr.aria-label]="'common.close' | translate">
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ 'chat.modal.title' | translate }}</ion-title>
      <ion-buttons slot="end" class="modal-editor__header-actions">
        @if (showCharacterPicker()) {
        <ion-chip id="open-select-char-modal-desktop" class="modal-editor__persona-chip" role="button" tabindex="0"
          [attr.aria-label]="'chat.modal.selectCharacter' | translate">
          @if (impersonateService.impersonate(); as impersonate) {
          <ion-avatar>
            <img class="h-full w-full object-cover" [attr.alt]="'common.characterAvatar' | translate"
              [src]="impersonate.avatar ?? '/assets/placeholder-avatar.png'" />
          </ion-avatar>
          } @else {
          <ion-avatar>
            <img class="h-full w-full object-cover" [attr.alt]="'common.characterAvatar' | translate"
              [src]="profile()?.avatar ?? '/assets/placeholder-avatar.png'" />
          </ion-avatar>
          }
          <ion-label class="modal-editor__persona-label">
            @if (impersonateService.impersonate(); as impersonate) {
            {{ impersonate.name }}
            } @else {
            {{ profile()?.displayName }}
            }
          </ion-label>
          <ion-icon name="chevron-down-outline" aria-hidden="true"></ion-icon>
        </ion-chip>
        <ion-action-sheet trigger="open-select-char-modal-desktop"
          [header]="'chat.modal.selectCharacter' | translate"
          [buttons]="actionSheetSelectCharButtons()"></ion-action-sheet>
        }
        @if (allowImage()) {
        <ion-button fill="clear" shape="round" (click)="addImage.emit()"
          [attr.aria-label]="'common.add' | translate">
          <ion-icon slot="icon-only" name="image-outline"></ion-icon>
        </ion-button>
        }
      </ion-buttons>
    </ion-toolbar>
    } @else {
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-chip id="open-select-char-modal" class="max-w-60" role="button" tabindex="0"
          [attr.aria-label]="'chat.modal.selectCharacter' | translate">
          @if (impersonateService.impersonate(); as impersonate) {
          <ion-avatar>
            <img class="h-full w-full object-cover" [attr.alt]="'common.characterAvatar' | translate"
              [src]="impersonate.avatar ?? '/assets/placeholder-avatar.png'" />
          </ion-avatar>
          } @else {
          <ion-avatar>
            <img class="h-full w-full object-cover" [attr.alt]="'common.characterAvatar' | translate"
              [src]="profile()?.avatar ?? '/assets/placeholder-avatar.png'" />
          </ion-avatar>
          }
          <ion-label class="whitespace-nowrap overflow-hidden text-ellipsis">
            @if (impersonateService.impersonate(); as impersonate) {
            {{ impersonate.name }}
            } @else {
            {{ profile()?.displayName }}
            }
          </ion-label>
        </ion-chip>
        <ion-action-sheet trigger="open-select-char-modal" [header]="'chat.modal.selectCharacter' | translate"
          [buttons]="actionSheetSelectCharButtons()"></ion-action-sheet>
        @if (allowImage()) {
        <ion-button class="sendButton" size="small" shape="round" fill="clear" (click)="addImage.emit()"
          [attr.aria-label]="'chat.actions.addImage' | translate">
          <ion-icon slot="icon-only" name="image-outline"></ion-icon>
        </ion-button>
        }
        <ion-button class="sendButton" size="small" shape="round" type="submit" (click)="sendMessage.emit()"
          [attr.aria-label]="'chat.actions.send' | translate">
          <ion-icon slot="icon-only" name="send"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    }
  </ion-header>

  <ion-content [scrollY]="false" class="modal-editor-content">
    <div class="modal-editor-body">
      @if (imageSelected()) {
      <div class="modal-editor-image relative flex-[0] max-h-[30%] contain-content">
        <img [src]="imageSelected()?.webPath" class="h-auto object-cover w-full max-h-full" alt="" />
        <ion-button class="absolute top-2 right-4" shape="round" size="small" (click)="removeImage.emit()"
          [attr.aria-label]="'chat.actions.removeImage' | translate">
          <ion-icon name="close" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      }
      <div class="modal-editor-field">
        @if (quotedMessage(); as quote) {
        <div class="quote">
          <div class="quote-content">
            <b>{{ quote.userData?.displayName }}</b>
            <div class="quote-text">
              <re-message-content [content]="quote.text" [preview]="true"></re-message-content>
            </div>
          </div>
          <div>
            <ion-button color="dark" fill="clear" (click)="quoteMessageHandler.emit()"
              [attr.aria-label]="'chat.impersonate.removeQuote' | translate">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </div>
        </div>
        }
        <re-chat-field type="full" [(text)]="text" [quotationEntity]="quotables()"></re-chat-field>
      </div>
    </div>
  </ion-content>

  @if (isDesktop()) {
  <ion-footer class="re-primary-action-footer modal-editor__footer">
    <ion-toolbar>
      <ion-button expand="block" (click)="sendMessage.emit()">
        <ion-icon slot="start" name="send"></ion-icon>
        {{ 'chat.modal.send' | translate }}
      </ion-button>
    </ion-toolbar>
  </ion-footer>
  }
</ng-template>

@if (isDesktop()) {
<ion-modal class="re-modal-editor re-modal-editor--desktop" [animated]="true" [backdropDismiss]="true"
  [canDismiss]="true" #textModal>
  <ng-template>
    <ng-container *ngTemplateOutlet="editorContent"></ng-container>
  </ng-template>
</ion-modal>
} @else {
<ion-modal class="re-modal-editor re-modal-editor--sheet" [animated]="true" #textModal [initialBreakpoint]="0.5"
  [breakpoints]="[0, 0.5, 0.75, 1]" [backdropBreakpoint]="0.75">
  <ng-template>
    <ng-container *ngTemplateOutlet="editorContent"></ng-container>
  </ng-template>
</ion-modal>
}
